import React,{Component} from 'react';
import {DiskCounterInEnterprise, DiskCounterInOpensale} from './counter'
import disk_sml from '@/images/purchase/disk_sml.png'

const DetailBox = ({showDetail})=>{
    const detailStyle = showDetail ? {} : {'display':'none'}
    return <div className="np-buy-groups-detail" style={detailStyle}>
    <div className="np-buy-groups-detail-tb">
        <h4>主体</h4>
        <table>
            <tbody>
            <tr>
                <th>品牌</th>
                <td>希捷 Seagate</td>
            </tr>
            <tr>
                <th>系列</th>
                <td>Expansion</td>
            </tr>
            <tr>
                <th>型号</th>
                <td>STEA2000400</td>
            </tr>
            <tr>
                <th>类型</th>
                <td>便携式存储</td>
            </tr>
            <tr>
                <th>外壳颜色</th>
                <td>黑色</td>
            </tr>
            <tr>
                <th>外壳材质</th>
                <td>塑料</td>
            </tr>
            </tbody>
        </table>
    </div>
    <div className="np-buy-groups-detail-tb">
        <h4>规格</h4>
        <table>
            <tbody>
            <tr>
                <th>容量</th>
                <td>2TB</td>
            </tr>
            <tr>
                <th>外部输出接口</th>
                <td>USB3.0</td>
            </tr>
            <tr>
                <th>系统要求</th>
                <td>Win10；win7；win8</td>
            </tr>
            <tr>
                <th>硬盘尺寸</th>
                <td>2.5英寸</td>
            </tr>
            <tr>
                <th>指示灯</th>
                <td>有</td>
            </tr>
            <tr>
                <th>尺寸（mm）</th>
                <td>117*80*14.8mm</td>
            </tr>
            <tr>
                <th>重量（g）</th>
                <td>170g</td>
            </tr>
            </tbody>
        </table>
    </div>
    <div className="np-buy-groups-detail-tb">
        <h4>包装清单</h4>
        <p className="np-buy-groups-detail-sum">移动硬盘x1、USB 3.0连接线 x1、快速入门指南 x1</p>
    </div>
</div>
}
export default class DiskSelector extends Component{
    constructor(props){
        super(props)
        this.state = {
            showDetail: false
        }
        this.toggleDetail = this.toggleDetail.bind(this)
    }

    toggleDetail() {
        const { showDetail } = this.state
        !showDetail && onStatBtnClick('prod_detail')
        this.setState({showDetail: !showDetail})
    }

    render(){
        const {showDetail} = this.state
        const { type, shoppingList:{diskCount}, changeShoppingList, priceList: {disk, diskActPrice}} = this.props;
        const diskCounterDom = {
            opensale: <DiskCounterInOpensale value={diskCount} changeShoppingList={changeShoppingList}/>,
            business: <DiskCounterInEnterprise value={diskCount} changeShoppingList={changeShoppingList}/>
        }
        return <div className="np-buy-groups">
            <h3>请选择搭配移动硬盘</h3>
            <div className="np-buy-groups-itembox">
                <div className="np-buy-groups-item">
                    <div className="np-buy-gibox">
                        <img src={disk_sml} alt="希捷硬盘" />
                        <div className="np-buy-gi-theme">
                            <h4>希捷2TB黑钻移动硬盘<em className="np-lbl-discount">省{disk - diskActPrice}元</em></h4>
                            <div className="np-buy-gi-price">
                                <em>{diskActPrice}元</em>
                                <del>{disk}元</del>
                                <a href="javascript:;" onClick={this.toggleDetail}>商品详情</a>
                            </div>
                        </div>
                    </div>
                    <DetailBox showDetail={showDetail}/>
                </div>
            </div>
            {diskCounterDom[type]}
        </div>
    }
}
DiskSelector.defaultProps = {
    type: 'opensale'
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/diskselector.jsx